document.addEventListener('DOMContentLoaded', () => {
  
    const activateFirstVisible = (selector) => {
      const elements = document.querySelectorAll(selector);
      let firstVisible = null;
  
      // Remove 'active' from all
      elements.forEach(el => {
    
        // If it's a nav item with a link, update aria-selected
        const button = el.querySelector('button');
        if (button) {
          button.setAttribute('aria-selected', 'false');
        }
    
        // If it's a slide, update aria-expanded
        if (el.classList.contains('wow-slide')) {
          el.setAttribute('aria-expanded', 'false');
        }
      });
  
      // Find first visible
      for (let el of elements) {
        const style = window.getComputedStyle(el);
        if (style.display !== 'none') {
          firstVisible = el;
    
          // If it's a nav item with a button, update aria-selected
          const button = el.querySelector('button');
          if (button) {
            button.setAttribute('aria-selected', 'true');
          }
    
          // If it's a slide, update aria-expanded
          if (el.classList.contains('wow-slide')) {
            el.setAttribute('aria-expanded', 'true');
          }
    
          break;
        }
      }
  
      return firstVisible;
    };
  
    // Initial activation
    activateFirstVisible('.wow-slide');
    activateFirstVisible('.wow-nav li');
  
    const buttons = document.querySelectorAll('.wow-nav button');

    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        userInteracted = true; // USER HAS INTERACTED

        const targetSelector = '#' + button.getAttribute('aria-controls');
        const targetElement = document.querySelector(targetSelector);
        const allSlides = document.querySelectorAll('.wow-slide');

        // Update nav active state
        buttons.forEach(btn => {
          btn.setAttribute('aria-selected', 'false');
        });
        button.setAttribute('aria-selected', 'true');

        // Update slides
        allSlides.forEach(slide => {
          slide.setAttribute('aria-expanded', 'false')
        });

        if (targetElement) {
          targetElement.setAttribute('aria-expanded', 'true');
        }
      });
    });

    buttons.forEach((button, index) => {
      button.addEventListener('keydown', (e) => {
        let newIndex = null;
    
        // Handle Left and Right arrow keys
        if (e.key === 'ArrowRight') {
          newIndex = (index + 1) % buttons.length;
        } else if (e.key === 'ArrowLeft') {
          newIndex = (index - 1 + buttons.length) % buttons.length;
        }
    
        if (newIndex !== null) {
          e.preventDefault();
          buttons[newIndex].focus();
          buttons[newIndex].click(); // trigger the panel change
        }
      });
    });
  });
  